// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardEventsSidebar_wrapper__MCRd5"};